const roleOptions = [
  { label: 'Land Owner', icon: '\u{1F331}' },
  { label: 'Developer', icon: '\u{1F3D7}\uFE0F' },
  { label: 'Investor', icon: '\u{1F4B0}' },
  { label: 'Broker', icon: '\u{1F4BC}' },
  { label: 'Channel Partner', icon: '\u{1F4C8}' },
];

function ContactSection({ selectedRole, showRoleError, onRoleChange, onStart }) {
  const normalizedRoleOptions = roleOptions.map((role) =>
    typeof role === 'string' ? { label: role, icon: '' } : role,
  );

  return (
    <section id="contact" data-section className="cta-wrap fade-up">
      <div className="cta-eye">Begin Your Journey</div>
      <h2 className="cta-title">I AM</h2>
      <p className="cta-sub">Select your role to unlock a personalised Trikon journey.</p>

      <div className="cta-form">
        <select
          className={`cta-select${showRoleError ? ' error' : ''}`}
          value={selectedRole}
          onChange={onRoleChange}
          aria-label="Select your role"
        >
          <option value="" disabled>
            Select your role...
          </option>
          {normalizedRoleOptions.map((role) => (
            <option key={role.label} value={role.label}>
              {role.icon ? `${role.icon} ${role.label}` : role.label}
            </option>
          ))}
        </select>

        <button type="button" className="cta-btn" onClick={onStart}>
          Get Started &rarr;
        </button>
      </div>
    </section>
  );
}

export default ContactSection;
